"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    "zh-cn": {
        "languageCode": "zh-cn",
        "copy": "复制"
    },
    "zh-tw": {
        "languageCode": "zh-tw",
        "copy": "複製"
    },
    "en-us": {
        "languageCode": "en-us",
        "copy": "Copy"
    }
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/locale.js
// module id = 698
// module chunks = 0